import api from "../../services/api";


export default async function getTipicAntContact(idmsg) {
	
	const { data } = await  api.get(`Mensajeanttipxti/${idmsg}`);
	return  data;
}

